/**
 * Bootstrap 5 toast + confirm helpers (replaces Noty).
 * Exposes: window.notify, window.casaConfirm
 */
(function () {
    'use strict';

    var TOAST_DELAY = 5000;
    var TYPE_CLASS = {
        success: 'text-bg-success',
        error: 'text-bg-danger',
        danger: 'text-bg-danger',
        warning: 'text-bg-warning',
        information: 'text-bg-info',
        info: 'text-bg-info',
        alert: 'text-bg-secondary',
        confirmation: 'text-bg-warning',
    };

    function ensureToastContainer() {
        var el = document.getElementById('casa-toast-container');
        if (el) return el;

        el = document.createElement('div');
        el.id = 'casa-toast-container';
        el.className = 'toast-container position-fixed top-0 start-50 translate-middle-x p-3';
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
        document.body.appendChild(el);
        return el;
    }

    function formatText(text) {
        if (text && typeof text === 'object') {
            if (text.errors) {
                var parts = [];
                Object.keys(text.errors).forEach(function (key) {
                    var val = text.errors[key];
                    parts.push(key + ': ' + (Array.isArray(val) ? val.join(', ') : val));
                });
                return parts.join('<br/>');
            }
            return String(text);
        }
        return text == null ? '' : String(text);
    }

    /**
     * @param {string|object} text
     * @param {string} [type=success]
     * @param {string} [layout] ignored (API compat with old notify)
     */
    window.notify = function notify(text, type) {
        if (!window.bootstrap || !bootstrap.Toast) {
            window.alert(formatText(text).replace(/<br\s*\/?>/gi, '\n'));
            return;
        }

        type = type || 'success';
        var bg = TYPE_CLASS[type] || TYPE_CLASS.alert;
        var darkClose = bg === 'text-bg-warning' || bg === 'text-bg-secondary';
        var closeBtnClass = darkClose ? 'btn-close' : 'btn-close btn-close-white';
        var html = formatText(text);
        var container = ensureToastContainer();

        var toastEl = document.createElement('div');
        toastEl.className = 'toast align-items-center border-0 ' + bg;
        toastEl.setAttribute('role', 'alert');
        toastEl.setAttribute('aria-live', 'assertive');
        toastEl.setAttribute('aria-atomic', 'true');
        toastEl.innerHTML =
            '<div class="d-flex align-items-center">' +
            '<div class="toast-body flex-grow-1 text-center">' + html + '</div>' +
            '<button type="button" class="' + closeBtnClass + ' me-2 m-auto flex-shrink-0" data-bs-dismiss="toast" aria-label="Close"></button>' +
            '</div>';

        container.appendChild(toastEl);

        var toast = bootstrap.Toast.getOrCreateInstance(toastEl, {
            animation: true,
            autohide: true,
            delay: TOAST_DELAY,
        });

        toastEl.addEventListener('hidden.bs.toast', function () {
            toast.dispose();
            toastEl.remove();
        });

        toast.show();
        return toast;
    };

    function ensureConfirmModal() {
        var el = document.getElementById('casa-confirm-modal');
        if (el) return el;

        el = document.createElement('div');
        el.id = 'casa-confirm-modal';
        el.className = 'modal fade';
        el.tabIndex = -1;
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML =
            '<div class="modal-dialog modal-dialog-centered">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<h5 class="modal-title" id="casa-confirm-title">Confirm</h5>' +
            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
            '</div>' +
            '<div class="modal-body" id="casa-confirm-body"></div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="casa-confirm-cancel">Cancel</button>' +
            '<button type="button" class="btn btn-primary" id="casa-confirm-ok">Yes</button>' +
            '</div>' +
            '</div>' +
            '</div>';
        document.body.appendChild(el);
        return el;
    }

    /**
     * @param {{text: string, title?: string, confirmLabel?: string, cancelLabel?: string, onConfirm?: Function, onCancel?: Function}} options
     */
    window.casaConfirm = function casaConfirm(options) {
        options = options || {};
        if (!window.bootstrap || !bootstrap.Modal) {
            if (window.confirm(formatText(options.text || '').replace(/<br\s*\/?>/gi, '\n'))) {
                if (typeof options.onConfirm === 'function') options.onConfirm();
            } else if (typeof options.onCancel === 'function') {
                options.onCancel();
            }
            return;
        }

        var modalEl = ensureConfirmModal();
        var titleEl = document.getElementById('casa-confirm-title');
        var bodyEl = document.getElementById('casa-confirm-body');
        var okBtn = document.getElementById('casa-confirm-ok');
        var cancelBtn = document.getElementById('casa-confirm-cancel');
        var confirmed = false;

        titleEl.textContent = options.title || 'Confirm';
        bodyEl.innerHTML = formatText(options.text || '');
        okBtn.textContent = options.confirmLabel || 'Yes';
        cancelBtn.textContent = options.cancelLabel || 'Cancel';

        var modal = bootstrap.Modal.getOrCreateInstance(modalEl, {
            backdrop: true,
            keyboard: true,
        });

        function onOk() {
            confirmed = true;
            modal.hide();
        }

        function onHidden() {
            okBtn.removeEventListener('click', onOk);
            modalEl.removeEventListener('hidden.bs.modal', onHidden);
            if (confirmed) {
                if (typeof options.onConfirm === 'function') options.onConfirm();
            } else if (typeof options.onCancel === 'function') {
                options.onCancel();
            }
        }

        okBtn.addEventListener('click', onOk);
        modalEl.addEventListener('hidden.bs.modal', onHidden);
        modal.show();
        return modal;
    };
}());
